import { render } from "./RemixView.vue?vue&type=template&id=121f6b5a&scoped=true"
import script from "./RemixView.vue?vue&type=script&lang=js"
export * from "./RemixView.vue?vue&type=script&lang=js"

import "./RemixView.vue?vue&type=style&index=0&id=121f6b5a&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/hosts/mageix.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121f6b5a"]])

export default __exports__